import { Primitive } from '../../../types/blocks/Primitive';

const TextBlock: Primitive = {
  name: 'TextBlock',
  friendlyName: 'Text',
  isInput: false,
  isPrimitive: true,
  isAvailableInEditor: true,
  tags: ['Text'],
  properties: {
    text: {
      type: 'String',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
  },
};

export default TextBlock;
